module.exports = __webpack_public_path__ + "img/default-user1.a220951b.png";